<template>
    <section id="home">
        <img style="width:100%;height:auto;" src="../assets/images/placeholder.png" />
        <div class="container">
            <h1>Available Products</h1>
            <h2>Choose a prdocut that you would like to configure</h2>
        </div>
    </section>
</template>

<script>
    
</script>

<style lang="scss" scoped>
    .container{
        text-align: center;
        max-width: 1040px;
        margin: 0 auto;
        padding: 60px 20px;

        h1{
            color: #000;
            margin-bottom: 10px;
            font-size: 36px;
        }

        h2{
            color: #000000;
            font-size: 23px;
        }
    }
</style>